class Comarca {
  constructor(comarca) {
    this.id = comarca.id;
    this.descricao = comarca.descricao;
  }
}

class Localidade {
  constructor(localidade) {
    this.idLocalidade = localidade.idLocalidade;
    this.nomeLocalidade = localidade.nomeLocalidade;
    this.tipoLocalidade = localidade.tipoLocalidade;
    this.vinculoLocalidade = localidade.vinculoLocalidade;
    this.nomeVinculoNoSIR = localidade.nomeVinculoNoSIR;
  }
}

export default class Serventia {

  constructor(serventia) {
    this.idCartorio = serventia.idCartorio;
    this.nome = serventia.nome;
    this.nomeFantasia = serventia.nomeFantasia;
    this.nomeTitularCartorio = serventia.nomeTitularCartorio;
    this.telefone = serventia.telefone;
    this.cargoTitular = serventia.cargoTitular;
    this.faz = serventia.faz;
    this.email = serventia.email;
    this.endereco = serventia.endereco;
    this.bairro = serventia.bairro;
    this.cep = serventia.cep;
    this.cnpj = serventia.cnpj;
    this.inscricaoEstadual = serventia.inscricaoEstadual;
    this.nomeLocalidade = serventia.nomeLocalidade;
    this.nomeComarca = serventia.nomeComarca;
    this.codigoUnidadeBoleto = serventia.codigoUnidadeBoleto;
    this.codigoSelo = serventia.codigoSelo;
    this.dataInstalacao = serventia.dataInstalacao;
    this.comarca = new Comarca(serventia.comarca);
    this.localidade = new Localidade(serventia.localidade);
  }
}




// WEBPACK FOOTER //
// ./src/domain/selo/serventia.js